import React, { useState } from "react";
import { ArrowUp, Mail } from "lucide-react";
import Modal from "../common/Modal";
import { getMailtoLink } from "../../config/contact";

const PRIVACY_TEXT = `WebPreview does not have a backend and makes no network calls of its own beyond loading the site you ask it to preview. Your URL history, favorite and custom devices, saved sessions, and theme preference are stored only in your browser's localStorage and are never transmitted to us or any third party. Clearing your browser's site data removes all of it. The only outbound requests this app makes are the iframe loads of the websites you choose to preview, and the mail/WhatsApp links you choose to open.`;

const TERMS_TEXT = `WebPreview is provided as-is, without warranty of any kind, to help you check how a website's layout responds to different viewport sizes. It renders pages inside standard browser iframes and cannot bypass a site's own embedding restrictions (X-Frame-Options or Content-Security-Policy: frame-ancestors) — some sites will not load here regardless. Device dimensions are approximate viewport sizes, not guarantees of pixel-perfect device emulation. You are responsible for how you use the sites you choose to preview and for complying with their own terms of use.`;

function scrollToTop() {
  const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top: 0, behavior: prefersReducedMotion ? "auto" : "smooth" });
}

function Footer() {
  const [openDoc, setOpenDoc] = useState(null);

  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <div className="app-footer-brand">
          <span className="app-footer-made-by">Made by Chekuri Satyanarayana Raja Varma</span>
          <span className="app-footer-copyright">
            © {new Date().getFullYear()} Chekuri Satyanarayana Raja Varma. All rights reserved.
          </span>
        </div>

        <nav className="app-footer-links" aria-label="Footer">
          <a href={getMailtoLink()} className="app-footer-link">
            <Mail size={14} strokeWidth={1.75} aria-hidden="true" />
            Contact
          </a>
          <button type="button" className="app-footer-link app-footer-link-button" onClick={() => setOpenDoc("privacy")}>
            Privacy
          </button>
          <button type="button" className="app-footer-link app-footer-link-button" onClick={() => setOpenDoc("terms")}>
            Terms
          </button>
        </nav>

        <button type="button" className="back-to-top" onClick={scrollToTop} aria-label="Back to top">
          <ArrowUp size={16} strokeWidth={1.75} aria-hidden="true" />
          Back to top
        </button>
      </div>

      {openDoc === "privacy" && (
        <Modal title="Privacy" onClose={() => setOpenDoc(null)}>
          <p>{PRIVACY_TEXT}</p>
        </Modal>
      )}

      {openDoc === "terms" && (
        <Modal title="Terms" onClose={() => setOpenDoc(null)}>
          <p>{TERMS_TEXT}</p>
        </Modal>
      )}
    </footer>
  );
}

export default Footer;
